const FieldCustom = ({
  field,
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  const setCustomValue = (value) => {
    if (props.convert) {
      setFieldValue(field.name, props.convert(value));
    } else {
      setFieldValue(field.name, value);
    }
  };

  const getDeepAttrValue = (_field, name=field.name, index=0) => {
    const attrs = name.split(".");
    const currentField = _field[attrs[index]];
    if(currentField){
      if(attrs.length > 1 && attrs.length-1 > index){
        return getDeepAttrValue(currentField, name, index+1);
      } else {
        return currentField;
      }
    }
  }

  return (
    <>
      <input
        type="text"
        {...field}
        {...props}
        onChange={(e) => {
          setCustomValue(e.target.value);
        }}
        className={
          "form-control" +
          (getDeepAttrValue(errors) && getDeepAttrValue(touched) ? " is-invalid" : "")
        }
      />
      {getDeepAttrValue(errors) && getDeepAttrValue(touched) && (
        <div className="invalid-feedback">{getDeepAttrValue(errors)}</div>
      )}
    </>
  );
};

export default FieldCustom;
